import { render, staticRenderFns } from "./WheelColorPicker.vue?vue&type=template&id=0bc64245&"
import script from "./WheelColorPicker.vue?vue&type=script&lang=js&"
export * from "./WheelColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports